import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import Twemoji from 'react-twemoji';
import { isConfigFlagEnabled } from '../config';
export const TwemojiWrapper = ({ children }) => {
    if (!isConfigFlagEnabled('twemoji')) {
        return _jsx(_Fragment, { children: children });
    }
    return _jsx(Twemoji, { children: children });
};
